import classNames from 'classnames'
import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'

type Props = {
  text: string
  to: string
  className?: string
}

export class LinkButton extends PureComponent<Props> {
  render() {
    const { to, text, className } = this.props
    const classes = classNames('bp3-button', className)

    return (
      <Link to={to} role="button" className={classes}>
        {text}
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/link-button/link-button.component.tsx